import { render, staticRenderFns } from "./AnnexesJurisdictional.vue?vue&type=template&id=d53755da"
import script from "./AnnexesJurisdictional.vue?vue&type=script&lang=js"
export * from "./AnnexesJurisdictional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports